
export default {
  name: "Articles",
};
